import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;

export const OPCOES_COMBO = [
  {
    key: 'E',
    label: 'Entrada'
  },
  {
    key: 'S',
    label: 'Saída'
  },
]

export const OPCOES_COMBO_PARC = [
  {
    key: 'A',
    label: 'ABERTO'
  },
  {
    key: 'P',
    label: 'PAGO'
  },
]

export default class ReparcelamentoForm extends Component {
  state = {
    registro: {
      tit_idf: 0,
      tit_controle: 0,
      tit_numero: 0,
      tit_tipo: { key: 'S', label: 'Saída', },
      tit_data_emissao: moment().format('DD/MM/YYYY'),
      tit_descricao: '',
      tit_pessoa: { key: '0', label: '', },
      tit_valor: 0,
      tit_tipo_doc: { key: '0', label: '', },
      tit_cond_pagto: { key: '0', label: '', },
      tit_plano_conta: { key: '0', label: '', },
      tit_cta_corrente: { key: '0', label: '', },
    },
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,

    formParcDisabled: true,
    activeKey: "dados",

    tipoDocSelect: [],
    ctaCorrenteSelect: [],

    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

    registroParcela: {
      tparc_parcela: 0,
      tparc_data_parcela: '',
      tparc_tipo_doc: { key: '0', label: '', },
      tparc_conta_corrente: { key: '0', label: '', },
      tparc_valor: 0,
      tparc_situacao: { key: 'A', label: 'ABERTO' },
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: '',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: '',
      pgto_cta_corrente: '',
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {

      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        visualizar: this.props.registroSelecionado.visualizar,
        editando: false,
        activeKey: "formaPagto",
      }, () => {
        this.buscaTipoDoc();
        this.buscaCtaCorrentes();
      });

      if (this.props.registroSelecionado.dados.tit_idf) {
        this.setState({
          editando: true,
          vlrDifParc: 0,
          activeKey: "formaPagto",
        });
      }

    }
  }

  componentDidMount() {

  }

  buscaTipoDoc = (value) => {
    this.setState({ tipoDocSelect: [] });
    axios.get('/tipoDocumentos/lista')
      .then(response => {
        const { data } = response;
        const tipoDocSelect = data.map(regList => {
          return {
            key: regList.td_idf,
            label: regList.td_descricao,
            cc: regList.td_cta_corrente
          }
        });
        this.setState({
          tipoDocSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  buscaCtaCorrentes = (value) => {
    this.setState({ ctaCorrenteSelect: [] })
    axios.get('/contasCorrente/lista')
      .then(response => {
        const { data } = response;
        const ctaCorrenteSelect = data.map(regList => {
          return {
            key: regList.cc_idf,
            label: regList.cc_descricao
          }
        });
        this.setState({
          ctaCorrenteSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }


  onOK = () => {

    if ((!this.state.listaParcelas) || (this.state.listaParcelas.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Informe as Parcelas', });
      return;
    }

    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.tit_valor)).toFixed(2));
    if (vlrDifParc !== 0) {
      Modal.warning({ title: 'Aviso!', content: 'O Valor Total do Título não Confere com o Valor Total das parcelas', });
      return;
    }

    const registro = {
      tit_idf: this.state.registro.tit_idf,
      listaParcelas: this.state.listaParcelas,
    };

    this.props.onSalvarClick(registro);
  };







  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onDateEmissaoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['tit_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ tit_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDateVencChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['tparc_data_parcela'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ tparc_data_parcela: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDatePagtoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['pgto_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ pgto_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  onChangeParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });
  };

  onChangeSituacaoParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });

    this.calculaVlrParc(value);
  };

  onChangeValorParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });

    this.calculaVlrParc(this.state.registroParcela.tparc_situacao);
  };



  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.tit_valor)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  calculaVlrParc = (situacao) => {
    let pgto_vlr_pago = this.state.registroParcela.tparc_valor;
    if (situacao.key === 'P') {
      pgto_vlr_pago = (parseFloat(this.state.registroParcela.tparc_valor) + parseFloat(this.state.registroParcela.pgto_vlr_acrescimo) - parseFloat(this.state.registroParcela.pgto_vlr_desconto)).toFixed(2);
    }
    this.setState({
      registroParcela: {
        ...this.state.registroParcela,
        pgto_vlr_acrescimo: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0,
        pgto_vlr_desconto: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0,
        pgto_vlr_pago,
      }
    });

  }

  onOKParcClick = (value) => {
    // console.log('this.state.registroParcela: ', this.state.registroParcela);

    if (this.state.registroParcela.tparc_situacao.key === 'P') {
      const dataAtual = moment().format('YYYY-MM-DD');
      const dataParc = moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (dataParc > dataAtual) {
        Modal.warning({ title: 'Aviso!', content: 'Data de Pagamento da Parcela maior que data atual.', });
        return;
      }
    }

    if ((this.state.registroParcela.tparc_valor) && (parseFloat(this.state.registroParcela.tparc_valor) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Valor da Parcela menor que zero.', });
      return;
    }

    if ((this.state.registroParcela.tparc_situacao.key === 'P') && (this.state.registroParcela.pgto_vlr_pago) && (parseFloat(this.state.registroParcela.pgto_vlr_pago) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Valor do Pagamento menor que zero.', });
      return;
    }

    if ((!this.state.registroParcela.tparc_tipo_doc) || (this.state.registroParcela.tparc_tipo_doc.key === '0') || (this.state.registroParcela.tparc_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registroParcela.tparc_conta_corrente) || (this.state.registroParcela.tparc_conta_corrente.key === '0') || (this.state.registroParcela.tparc_conta_corrente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente', });
      return;
    }

    const iInd = this.state.listaParcelas ? this.state.listaParcelas.findIndex(registro => String(registro.tparc_parcela) === String(this.state.registroParcela.tparc_parcela)) : -1;

    if (iInd >= 0) {

      this.state.listaParcelas[iInd].tparc_data_parcela = moment(this.state.registroParcela.tparc_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaParcelas[iInd].tparc_tipo_doc = this.state.registroParcela.tparc_tipo_doc.key;
      this.state.listaParcelas[iInd].tparc_conta_corrente = this.state.registroParcela.tparc_conta_corrente.key;
      this.state.listaParcelas[iInd].tparc_situacao = this.state.registroParcela.tparc_situacao.key;
      this.state.listaParcelas[iInd].tparc_valor = this.state.registroParcela.tparc_valor;
      this.state.listaParcelas[iInd].tparc_obs = this.state.registroParcela.tparc_obs;
      this.state.listaParcelas[iInd].td_descricao = this.state.registroParcela.tparc_tipo_doc.label;
      this.state.listaParcelas[iInd].cc_descricao = this.state.registroParcela.tparc_conta_corrente.label;
      this.state.listaParcelas[iInd].situacao_parcela = this.state.registroParcela.tparc_situacao.label;
      this.state.listaParcelas[iInd].pgto_vlr_desconto = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0;
      this.state.listaParcelas[iInd].pgto_vlr_acrescimo = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0;
      this.state.listaParcelas[iInd].pgto_vlr_pago = this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_pago : 0;
      this.state.listaParcelas[iInd].pgto_vlr_restante = this.state.registroParcela.pgto_vlr_restante;
      this.state.listaParcelas[iInd].pgto_data = this.state.registroParcela.tparc_situacao.key === 'P' ? moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
      this.state.listaParcelas[iInd].pgto_cta_corrente = this.state.registroParcela.tparc_conta_corrente.key;

    } else {

      this.state.listaParcelas.push({
        tparc_parcela: this.state.registroParcela.tparc_parcela,
        tparc_data_parcela: moment(this.state.registroParcela.tparc_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        tparc_tipo_doc: this.state.registroParcela.tparc_tipo_doc.key,
        tparc_conta_corrente: this.state.registroParcela.tparc_conta_corrente.key,
        tparc_valor: this.state.registroParcela.tparc_valor,
        tparc_situacao: this.state.registroParcela.tparc_situacao.key,
        tparc_obs: this.state.registroParcela.tparc_obs,
        td_descricao: this.state.registroParcela.tparc_tipo_doc.label,
        cc_descricao: this.state.registroParcela.tparc_conta_corrente.label,
        situacao_parcela: this.state.registroParcela.tparc_situacao.label,
        pgto_vlr_desconto: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0,
        pgto_vlr_acrescimo: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0,
        pgto_vlr_pago: this.state.registroParcela.tparc_situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_pago : 0,
        pgto_vlr_restante: this.state.registroParcela.pgto_vlr_restante,
        pgto_data: this.state.registroParcela.tparc_situacao.key === 'P' ? moment(this.state.registroParcela.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        pgto_cta_corrente: this.state.registroParcela.tparc_conta_corrente.key,
      });

    }


    this.setState({
      formParcDisabled: true,
      activeKey: "formaPagto",

      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0', label: '', },
        tparc_conta_corrente: { key: '0', label: '', },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO' },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }
    },
      this.calculaTotalParc()
    );

  };

  onAdicionarClick = registro => {
    let registroParcela = {
      tparc_parcela: this.state.listaParcelas.length + 1,
      tparc_data_parcela: moment().format('DD/MM/YYYY'),
      tparc_tipo_doc: {
        key: '0',
        label: '',
      },
      tparc_conta_corrente: {
        key: '0',
        label: '',
      },
      tparc_situacao: { key: 'A', label: 'ABERTO' },
      tparc_valor: 0,
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: 'ABERTO',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: '',
      pgto_cta_corrente: '',
    }

    this.setState({
      registroParcela,
      formParcDisabled: false,
      activeKey: "parcela",
    });
  }

  onEditarParcelaClick = registro => {
    // console.log('PARCELA: ', registro);

    let registroParcela = {
      tparc_parcela: registro.tparc_parcela,
      tparc_data_parcela: moment(registro.tparc_data_parcela, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      tparc_tipo_doc: {
        key: registro.tparc_tipo_doc,
        label: registro.td_descricao,
      },
      tparc_conta_corrente: {
        key: registro.tparc_conta_corrente,
        label: registro.cc_descricao,
      },
      tparc_situacao: {
        key: registro.tparc_situacao,
        label: registro.situacao_parcela,
      },
      tparc_valor: registro.tparc_valor,
      tparc_obs: registro.tparc_obs ? registro.tparc_obs : '',
      td_descricao: registro.td_descricao,
      cc_descricao: registro.cc_descricao,
      situacao_parcela: registro.situacao_parcela,
      pgto_vlr_desconto: registro.pgto_vlr_desconto,
      pgto_vlr_acrescimo: registro.pgto_vlr_acrescimo,
      pgto_vlr_pago: registro.pgto_vlr_pago && registro.pgto_vlr_pago === 0 ? registro.pgto_vlr_pago : registro.tparc_valor,
      pgto_vlr_restante: registro.pgto_vlr_restante,
      pgto_data: registro.pgto_data && registro.pgto_data !== '' ? moment(registro.pgto_data, 'YYYY-MM-DD').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
      pgto_cta_corrente: registro.pgto_cta_corrente,
    }

    this.setState({
      registroParcela,
      formParcDisabled: false,
      activeKey: "parcela",
    });

  };

  onExcluirParcelaClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const { listaParcelas, total } = this.state;
        const registroIndex = listaParcelas.findIndex(tar => tar.tparc_parcela === registro.tparc_parcela)
        listaParcelas.splice(registroIndex, 1);
        this.setState({
          listaParcelas: listaParcelas.concat([]),
          total: total - 1,
          carregando: false,
        },
          this.calculaTotalParc()
        )
      }
    })
  };


  onCancelarParcClick = (value) => {
    this.setState({
      formParcDisabled: true,
      activeKey: "formaPagto",
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0', label: '', },
        tparc_conta_corrente: { key: '0', label: '', },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO' },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }
    });
  };



  renderValor = (tparc_valor) => {
    return (
      <span> {numeral(parseFloat(tparc_valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderAcoesParcelas = (registro) => {
    if (registro.tparc_situacao === 'P') {
      return
    } else {
      return (
        <ButtonGroup size="small">
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarParcelaClick(registro)} icon="edit" />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirParcelaClick(registro)} icon="delete" />
          </Tooltip>
        </ButtonGroup>
      );
    }
  };


  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    },
      this.montaTipo(this.state.registro.tit_tipo.key)
    );
  }




  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------




  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { tit_idf, tit_controle, tit_numero, tit_tipo, tit_data_emissao,
      tit_pessoa, tit_descricao, tit_valor, tit_cond_pagto, tit_tipo_doc,
      tit_plano_conta, tit_cta_corrente,
    } = this.state.registro;

    const { tparc_parcela, tparc_situacao, tparc_data_parcela, tparc_valor, pgto_vlr_desconto,
      pgto_vlr_acrescimo, pgto_vlr_pago, tparc_tipo_doc, pgto_data, tparc_conta_corrente
    } = this.state.registroParcela;

    const { carregandoForm, tipoDocSelect, ctaCorrenteSelect, listaParcelas, vlrTotalParc, vlrDifParc,
      editando, formParcDisabled } = this.state;

    // console.log('ReparcelamentoForm.this.state: ', this.state);

    return (
      <Modal
        title={"Reparcelamento Financeiro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <div className="card-container" style={{ minHeight: 0 }}>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <Form>
                <Row>
                  <Col xs={24}>
                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Controle</span>
                      <InputForm
                        id="tit_controle"
                        ref="tit_controle"
                        value={tit_controle}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="tit_numero"
                        ref="tit_numero"
                        value={tit_numero}
                        type="number"
                        decimalScale={0}
                        readOnly
                      />
                    </Col>
                    <Col xs={24} sm={5} className="camposEspacoDireita">
                      <span>Tipo</span>
                      <InputForm
                        type="select"
                        id="tit_tipo"
                        ref="tit_tipo"
                        value={tit_tipo}
                        placeholder="Selecione o Tipo"
                        data={OPCOES_COMBO}
                        validator={value => Boolean(value)}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={7} style={{ marginTop: 4 }}>
                      <span>Data Emissão</span>
                      <DatePicker
                        onChange={this.onDateEmissaoChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(tit_data_emissao, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Col>

                  <Col xs={12} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Descrição</span>
                    <InputForm
                      id="tit_descricao"
                      ref="tit_descricao"
                      value={tit_descricao}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                    <span>Cliente/Fornecedor</span>
                    <InputForm
                      id="tit_pessoa"
                      ref="tit_pessoa"
                      value={tit_pessoa.label}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Valor</span>
                    <InputForm
                      type="number"
                      id="tit_valor"
                      ref="tit_valor"
                      value={tit_valor}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Tipo Documento</span>
                    <InputForm
                      id="tit_tipo_doc"
                      ref="tit_tipo_doc"
                      value={tit_tipo_doc.label}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                    <span>Cond Pagto</span>
                    <InputForm
                      id="tit_cond_pagto"
                      ref="tit_cond_pagto"
                      value={tit_cond_pagto.label}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Plano de Contas</span>
                    <InputForm
                      id="tit_plano_conta"
                      ref="tit_plano_conta"
                      value={tit_plano_conta.label}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                    <span>Conta Corrente</span>
                    <InputForm
                      id="tit_cta_corrente"
                      ref="tit_cta_corrente"
                      value={tit_cta_corrente.label}
                      readOnly
                    />
                  </Col>

                </Row>
              </Form>
            </TabPane>

            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 271 }}>
                <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 50, }}>
                  <Col xs={20}>
                    {vlrDifParc === 0 ? null : (
                      <div>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(tit_valor)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </div>
                    )}
                  </Col>
                  <Col xs={4}>
                    <Button
                      type="primary"
                      onClick={this.onAdicionarClick}
                      className="btn-primary"
                    >
                      Adicionar
                    </Button>
                  </Col>
                </Row>

                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaParcelas}
                  pagination={false}
                  rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                >
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_data_parcela"
                    dataIndex="tparc_data_parcela"
                    title="Data Venc"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderData}
                  />
                  <Column
                    key="tparc_valor"
                    dataIndex="tparc_valor"
                    title="Valor Parc"
                    render={this.renderValor}
                    width={80}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="situacao_parcela"
                    dataIndex="situacao_parcela"
                    title="Situação"
                    width={80}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Documento"
                    width={300}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesParcelas}
                    width={70}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>

              </div>
            </TabPane>


            <TabPane tab="Parcela" key="parcela" disabled={formParcDisabled}>
              <div style={{ height: 271 }}>
                <Form>
                  <Row>

                    <Col xs={24}>
                      <Col xs={24} sm={4} className="camposEspacoDireita">
                        <span>Parcela</span>
                        <InputForm
                          id="tparc_parcela"
                          ref="tparc_parcela"
                          onChange={this.onChangeParcela}
                          value={tparc_parcela}
                          disabled={true}
                        />
                      </Col>

                      <Col xs={24} sm={4} className="camposEspacoDireita">
                        <span>Situação *</span>
                        <InputForm
                          type="select"
                          id="tparc_situacao"
                          ref="tparc_situacao"
                          value={tparc_situacao}
                          placeholder="Selecione"
                          onChange={this.onChangeSituacaoParcela}
                          data={OPCOES_COMBO_PARC}
                          validator={value => Boolean(value)}
                        />
                      </Col>


                      <Col xs={24} sm={8} style={{ marginTop: 4 }} className="camposEspacoDireita">
                        <span>Data Vencimento *</span>
                        <DatePicker
                          onChange={this.onDateVencChange}
                          format="DD/MM/YYYY"
                          showToday={true}
                          allowClear={false}
                          value={moment(tparc_data_parcela, "DD/MM/YYYY", true)}
                          style={{ width: "100%" }}
                        />
                      </Col>
                      {tparc_situacao.key === 'A' ? null : (
                        <Col xs={24} sm={8} style={{ marginTop: 4 }}>
                          <span>Data Pagto *</span>
                          <DatePicker
                            onChange={this.onDatePagtoChange}
                            format="DD/MM/YYYY"
                            showToday={true}
                            allowClear={false}
                            value={moment(pgto_data, "DD/MM/YYYY", true)}
                            style={{ width: "100%" }}
                          />
                        </Col>
                      )}
                    </Col>

                    <Col xs={24}>
                      <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                        <span>Valor Parcela *</span>
                        <InputForm
                          type="number"
                          id="tparc_valor"
                          ref="tparc_valor"
                          value={tparc_valor}
                          onChange={this.onChangeValorParcela}
                        />
                      </Col>
                      <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                        <span>Valor Desconto</span>
                        <InputForm
                          type="number"
                          id="pgto_vlr_desconto"
                          ref="pgto_vlr_desconto"
                          value={pgto_vlr_desconto}
                          onChange={this.onChangeValorParcela}
                          disabled={tparc_situacao.key === 'A'}
                        />
                      </Col>
                      <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                        <span>Valor Acréscimo</span>
                        <InputForm
                          type="number"
                          id="pgto_vlr_acrescimo"
                          ref="pgto_vlr_acrescimo"
                          value={pgto_vlr_acrescimo}
                          onChange={this.onChangeValorParcela}
                          disabled={tparc_situacao.key === 'A'}
                        />
                      </Col>
                      <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                        <span>Valor Pagto *</span>
                        <InputForm
                          type="number"
                          id="pgto_vlr_pago"
                          ref="pgto_vlr_pago"
                          value={pgto_vlr_pago}
                          onChange={this.onChangeParcela}
                          disabled={true}
                        />
                      </Col>
                    </Col>

                    <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Tipo Documento *</span>
                      <InputForm
                        type="select"
                        id="tparc_tipo_doc"
                        ref="tparc_tipo_doc"
                        value={tparc_tipo_doc}
                        placeholder="Selecione o Documento"
                        onChange={this.onChangeParcela}
                        data={tipoDocSelect}
                        validator={value => Boolean(value)}
                        showSearch
                      />
                    </Col>

                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <span>Conta Corrente *</span>
                      <InputForm
                        type="select"
                        id="tparc_conta_corrente"
                        ref="tparc_conta_corrente"
                        value={tparc_conta_corrente}
                        placeholder="Selecione uma Conta"
                        onChange={this.onChangeParcela}
                        data={ctaCorrenteSelect}
                        validator={value => Boolean(value)}
                        showSearch
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24}>
                      {this.state.visualizar ? null : (
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={this.onOKParcClick}
                          className="btn-salvar"
                        >
                          Salvar Parcela
                        </Button>
                      )}

                      <Button
                        htmlType="button"
                        onClick={this.onCancelarParcClick}
                        style={{ marginLeft: 15 }}
                        className="btn-fechar"
                      >
                        Voltar
                      </Button>
                    </Col>
                  </Row>

                </Form>
              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReparcelamentoForm.js